import { render, staticRenderFns } from "./UniqueTable.vue?vue&type=template&id=6978d52a"
import script from "./UniqueTable.vue?vue&type=script&lang=js"
export * from "./UniqueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports